<template lang="html">
    <ds-modal
        :is-open="isOpen"
        size="med"
        class="ftu-modal"
        @close="close"
    >
        <ds-icon-button
            name="x"
            class="close-button"
            @click="close"
        />

        <div class="feature-ftu-modal">
            <ds-illustration
                v-if="illustration"
                class="illustration"
                :name="illustration"
            />

            <h1 data-qa="title">
                {{ title }}
            </h1>

            <p data-qa="description">
                {{ description }}
            </p>

            <ds-filled-button
                class="large"
                data-qa="start-tour-button"
                @click="startTour"
            >
                Take the tour
            </ds-filled-button>

            <ds-text-button
                class="large"
                data-qa="ftu-cta-button"
                @click="handleClick"
            >
                {{ ctaButtonText }}
            </ds-text-button>


            <feature-tour-modal
                data-qa="feature-tour-modal"
                :is-open="tourModalOpen"
                :slides="slides"
                @complete="completeTour"
                @close="exitTour"
            />
        </div>
    </ds-modal>
</template>

<script>
import FeatureTourModal from './FeatureTourModal';

export default {
    components: {
        FeatureTourModal,
    },

    props: {
        isOpen: Boolean,
        ctaButtonText: String,
        description: String,
        featureName: String,
        slides: {
            type: Array,
            default: () => [],
        },
        title: String,
        tourKey: String,
        illustration: String,
    },

    data() {
        return {
            tourModalOpen: false,
        };
    },

    methods: {
        completeTour() {
            this.$emit('complete');

            this.tourModalOpen = false;
        },

        exitTour() {
            this.tourModalOpen = false;
        },

        startTour() {
            this.tourModalOpen = true;
        },

        handleClick() {
            this.$emit('feature-ftu-action');
        },

        close() {
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss" scoped>
    .ftu-modal {
        --modal-padding: $spacing-200;
    }

    .feature-ftu-modal {
        padding: 0 $spacing-400 $spacing-400;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    h1 {
        font-family: $font-family-secondary-title;
        font-weight: $font-weight-bold;
        font-size: px-to-rem(32px);
        padding: 0 6rem;
    }

    p {
        font-size: $font-size-md;
        max-width: px-to-rem(500px);
        padding: $spacing-200 $spacing-200 $spacing-400;
        line-height: $line-height-lg;
    }

    button {
        margin-bottom: $spacing-200;
    }

    .image {
        border-radius: $border-radius;
        overflow: hidden;
        max-width: px-to-rem(600px);
    }

    .illustration {
        margin: $spacing-400;
    }

    .close-button {
        max-width: px-to-rem(40px);
        margin: $spacing-200 $spacing-200 0;
    }
</style>
